import { render } from "./ApiClientCard.vue?vue&type=template&id=313492d6&scoped=true"
import script from "./ApiClientCard.vue?vue&type=script&lang=js"
export * from "./ApiClientCard.vue?vue&type=script&lang=js"

import "./ApiClientCard.vue?vue&type=style&index=0&id=313492d6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313492d6"]])

export default __exports__